export const MobileAppVersionInfoConstants = {
	PLATFORM: "Platform",
	VERSION: "Sürüm No",
	LOCALIZATION_KEY: "Yerelleştirme Anahtarı",
	RELEASE_ORDER: "Yayın Sırası",
	DISPLAY_ORDER: "Görüntü Sırası",
	HAS_WARNING: "Uyarı Göster",
};

export const PLATFORM_OPTIONS = [
	{ label: "IOS", value: "IOS" },
	{ label: "Android", value: "ANDROID" },
	{ label: "Huawei", value: "HUAWEI" },
];

export const APP_OPTIONS = [
	{ label: "Moments", value: 1 },
	{ label: "IKCATI", value: 2 },
];